import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './InstagramImage.module.sass';

function InstagramImage(props) {
  const { image } = props;

  useEffect(() => {
    window.lazyLoad.update();
  }, []);

  return (
    <div className={styles['image-block']}>
      <a href={image.permalink} target="_blank" rel="noreferrer">
        <div className={styles.image}>
          <img
            className="lazyload"
            data-src={image.media_type === 'VIDEO' ? image.thumbnail_url : image.media_url}
            alt={image.caption}
          />
        </div>
      </a>
    </div>
  );
}

InstagramImage.propTypes = {
  image: PropTypes.shape({
    media_type: PropTypes.string,
    media_url: PropTypes.string,
    permalink: PropTypes.string,
    thumbnail_url: PropTypes.string,
    caption: PropTypes.string,
  }).isRequired,
};

export default InstagramImage;
